import script from "./OtherDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherDetails.vue?vue&type=script&setup=true&lang=js"

import "./OtherDetails.vue?vue&type=style&index=0&id=7e2049c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2049c6"]])

export default __exports__